<div
  class="h-14 flex w-full py-3.5 items-center justify-between px-6 bg-navy title font-main text-3xl font-bold text-navy-90 border-b border-navy-30"
>
  {{ buildTranslationKey('title') | translate }}
  <span *ngVar="sendingRequestBtnLoader$ | async as loading" class="flex gap-3">
    @if (loading === false) {
      <app-new-button [type]="'secondary'" [size]="'responsive'" [svgIconPath]="'refresh'" (click)="resetBtnClick()">
        {{ buildTranslationKey('reset') | translate }}
      </app-new-button>

      <app-new-button
        [svgIconPath]="'eye_white'"
        [size]="'responsive'"
        [type]="'secondary'"
        (click)="navigateToPreviewTab()"
      >
        {{ buildTranslationKey('preview') | translate }}
      </app-new-button>
    }

    <app-new-button
      [type]="'primary'"
      [size]="'responsive'"
      [svgIconPath]="'Resolve2'"
      [loading]="loading"
      [disabled]="!enableSaveBtn && !loading"
      [saveButtonSizeDuringLoading]="true"
      [ngbTooltip]="buildTranslationKey('saveTooltip') | translate"
      [tooltipClass]="'default-tooltip w-40'"
      [placement]="'bottom'"
      (click)="saveSettings()"
    >
      {{ buildTranslationKey('save') | translate }}
    </app-new-button>
  </span>
</div>

<div class="w-full h-full overflow-hidden">
  <div class="overflow-y-auto h-full mt-4 box-border pb-8 px-6 border-r border-navy-30">
    <div class="pr-4 flex flex-col gap-5">
      <span class="text-2xl font-bold text-navy-90">
        {{ buildTranslationKey('OrganizationLogoTitle') | translate }}
      </span>

      <app-image-edit
        [imageUrl]="fullLogo"
        [logoClasses]="'w-auto max-h-14'"
        [logoPlaceholderClasses]="'w-40 h-14'"
        [titleTranslationKey]="buildTranslationKey('fullLogo.title')"
        [descriptionTranslationKey]="buildTranslationKey('fullLogo.description')"
        [placeholderTranslationKey]="buildTranslationKey('fullLogo.placeholder')"
        (imageUrlChange)="handleFullLogoChange($event)"
      ></app-image-edit>

      <app-image-edit
        [imageUrl]="favicon"
        [logoClasses]="'w-auto max-h-8'"
        [logoPlaceholderClasses]="'w-8 h-8'"
        [titleTranslationKey]="buildTranslationKey('favicon.title')"
        [descriptionTranslationKey]="buildTranslationKey('favicon.description')"
        [placeholderTranslationKey]="buildTranslationKey('favicon.placeholder')"
        (imageUrlChange)="handleFaviconChange($event)"
      ></app-image-edit>

      <span class="text-2xl font-bold text-navy-90">
        {{ buildTranslationKey('colorPaletteTitle') | translate }}
      </span>
      <div class="flex flex-row items-center pl-5 justify-between max-w-125">
        <span class="text-xl text-navy-90">
          {{ buildTranslationKey('bgColor') | translate }}
        </span>
        @if (bgColorPickerControl) {
          <app-color-picker-palette
            [formControl]="bgColorPickerControl"
            (colorChanged)="onColorChanged()"
          ></app-color-picker-palette>
        }
      </div>

      <span class="text-2xl font-bold text-navy-90">
        {{ buildTranslationKey('buttonsIconsTitle') | translate }}
      </span>
      <div class="flex flex-row items-center pl-5 justify-between max-w-125">
        <span class="text-xl text-navy-90">
          {{ buildTranslationKey('primaryColor') | translate }}
        </span>
        @if (primaryColorPickerControl) {
          <app-color-picker-palette
            [formControl]="primaryColorPickerControl"
            (colorChanged)="onColorChanged()"
          ></app-color-picker-palette>
        }
      </div>
      <div class="flex flex-row items-center pl-5 justify-between max-w-125">
        <span class="text-xl text-navy-90">
          {{ buildTranslationKey('buttonTextColor') | translate }}
        </span>
        @if (textColorPickerControl) {
          <app-color-picker-palette
            [formControl]="textColorPickerControl"
            (colorChanged)="onColorChanged()"
          ></app-color-picker-palette>
        }
      </div>
    </div>
  </div>
</div>
